import React from "react";
import { Button, Chip } from "@mui/material";
import { isAllowedExternalNavUrl, isExternalNavItem } from "./constants";

const SidebarNavigation = ({
  isCollapsed,
  isMobile,
  filteredNavigationItems,
  location,
  handleItemClick,
  isNavigationItemActive,
}) => {
  return (
    <div
      className={`sidebar-navigation ${isCollapsed && !isMobile ? "collapsed" : ""}`}
    >
      <div className="navigation-items">
        {filteredNavigationItems.map((item) => {
          const Icon = item.icon;
          // SECURITY: Use centralized function to determine active state
          const isActive = isNavigationItemActive(item, location.pathname);
          const safeExternalHref =
            isExternalNavItem(item) && isAllowedExternalNavUrl(item.url) ? item.url : null;

          return (
            <Button
              key={item.title}
              className={`nav-item ${isActive ? "active" : ""} ${
                isCollapsed && !isMobile ? "collapsed" : ""
              }`}
              onClick={() => handleItemClick(item)}
              title={isCollapsed && !isMobile ? item.title : ""}
              {...(safeExternalHref
                ? {
                    component: "a",
                    href: safeExternalHref,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "aria-label": `${item.title} (opens in new tab)`,
                  }
                : {})}
              sx={{
                height: isCollapsed && !isMobile ? "44px" : "48px",
                width: isCollapsed && !isMobile ? "44px" : "100%",
                justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
                padding: isCollapsed && !isMobile ? "0" : "0 16px",
                borderRadius: "12px" /* rounded-lg */,
                gap: "12px",
                textTransform: "none",
                backgroundColor: isActive ? "#9D6AC4" : "transparent",
                color: isActive ? "#ffffff" : "#2c2c3a",
                boxShadow: isActive ? "0 2px 8px rgba(157,106,196,0.2)" : "none",
                "&:hover": {
                  backgroundColor: isActive ? "#E69770" : "rgba(157,106,196,0.12)",
                  color: isActive ? "#ffffff" : "#2c2c3a",
                },
                transition: "all 0.2s ease",
                ...(isCollapsed &&
                  !isMobile && {
                    marginLeft: "auto",
                    marginRight: "auto",
                    minWidth: "44px",
                    maxWidth: "44px",
                  }),
              }}
            >
              <Icon
                className="nav-icon"
                style={{ width: "20px", height: "20px", flexShrink: 0 }}
              />
              {(!isCollapsed || isMobile) && (
                <>
                  <span className="nav-text">{item.title}</span>
                  {item.isBeta && (
                    <Chip
                      label="Beta"
                      size="small"
                      variant="outlined"
                      sx={{
                        height: "22px",
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        marginLeft: "auto",
                        backgroundColor: isActive ? "rgba(230, 151, 112, 0.15)" : "transparent",
                        color: isActive ? "#ffffff" : "#e69770",
                        borderColor: isActive ? "rgba(255,255,255,0.5)" : "#e69770",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderRadius: "6px",
                        "& .MuiChip-label": {
                          padding: "0 8px",
                        },
                      }}
                    />
                  )}
                </>
              )}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarNavigation;
